import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { ImpersonationService } from 'app/core/auth/impersonation.service';

/** Shown while an admin is logged in as someone else, with the way back. */
@Component({
  selector: 'impersonation-banner',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, MatButtonModule, MatIconModule, TranslateModule],
  template: `
    <div *ngIf="impersonation.isActive"
         class="impersonation-banner flex flex-wrap items-center justify-center gap-3 w-full px-4 py-2 bg-amber-500 text-black text-sm font-medium print:hidden">
      <mat-icon class="icon-size-5 text-black" [svgIcon]="'heroicons_outline:eye'"></mat-icon>
      <span>
        {{ 'You are logged in as' | translate }} <strong>{{ impersonation.impersonatedName }}</strong>
        <span *ngIf="impersonation.impersonatedRole">({{ impersonation.impersonatedRole | translate }})</span>
      </span>
      <button mat-flat-button class="return-btn !bg-black !text-white !h-8 !min-h-8" [disabled]="isReturning" (click)="returnToOwnAccount()">
        {{ (isReturning ? 'Returning...' : 'Return to my account') | translate }}
      </button>
    </div>
  `,
})
export class ImpersonationBannerComponent {
  readonly impersonation = inject(ImpersonationService);
  private readonly cdr = inject(ChangeDetectorRef);
  isReturning = false;

  returnToOwnAccount(): void {
    this.isReturning = true;
    this.impersonation.stop().subscribe({
      error: () => {
        this.isReturning = false;
        this.cdr.markForCheck();
      },
    });
  }
}
